import { rem, clearFix } from 'polished'
import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'
import typography from '../../../utils/typography'
import IconArrowDown from '../../../vectors/IconArrowDown'

const button = {
  large: { height: 60 },
  small: { height: 42 },
  outline: {
    height: 4
  }
}

export const Arrow = styled(IconArrowDown)`
  position: absolute;
  top: 45%;
  right: 25px;
  ${media.MediumScreenUp`
  right: 8%;
  `}
  ${media.LargeScreenUp`
  right: 10%;
  `}
  transform: scale(${(props) => (props.open ? '1.2' : '-1.2')});
`

export const ResponsiveSelectFlex = styled(Box)`
  position: relative;
  width: 320px;
  z-index: 1000;
  text-transform: uppercase;
  text-align: left;
  font-weight: 600;
  color: ${(props) => props.theme.colors.blue};
  border-right: 1px solid ${(props) => props.theme.colors.blue};
  ${media.MediumScreenUp`
  &::before {
    content:'';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 99%;
    height: ${typography.rhythm(1.97)};
  }
  `};

  .rrs {
    position: relative;
    box-sizing: border-box;
    display: block;
    width: 100%;
  }

  .rrs *,
  .rrs *::before,
  .rrs *::after {
    box-sizing: border-box;
  }

  .rrs__button {
    position: relative;
    cursor: pointer;
    color: ${(props) => props.theme.colors.grey_light_op65};
    font-size: ${(props) => rem(props.theme.fontSizes[2])};
    height: ${rem(42)};
    line-height: ${rem(42)};
    ${media.MediumScreenUp`
    font-size: ${(props) => rem(props.theme.fontSizes[3])};
    height: ${typography.rhythm(1.97)};
    line-height: ${typography.rhythm(1.97)};
    `}
    background: white;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    transition: transform 0.3s ${(props) => props.theme.ease.ease_out_expo};
    &:hover {
      color: ${(props) => props.theme.colors.grey_light};
    }
  }
  .rrs__button.rrs__button--disabled:focus .rrs__label,
  .rrs__button--disabled {
    color: ${(props) => props.theme.colors.grey_light_op30};
    outline: 0;
    background: #e0e3e8;
    cursor: default;
    path {
      fill: ${(props) => props.theme.colors.grey_light_op30};
    }
    &:hover {
      color: ${(props) => props.theme.colors.grey_light_op30};
    }
  }
  .rrs__button:focus {
    outline: 0;
  }
  .rrs__button + .rrs__options {
    font-size: ${(props) => rem(props.theme.fontSizes[2])};
    list-style: none;
    padding: 0;
    margin: 0;
    background: white;
    position: absolute;
    z-index: 2;
    border-top: 1px solid ${(props) => props.theme.colors.grey_light_op65};
    top: ${rem(typography.rhythm(1.97) - button.outline.height + 4)};
    ${media.MediumScreenUp`
    border-top: 5px solid ${(props) => props.theme.colors.blue};
    top: ${rem(typography.rhythm(1.97) - button.outline.height)};
    `};
    width: 100%;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  }

  .rrs--options-visible .rrs__options {
    height: auto;
    visibility: visible;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 230px;
    box-shadow: 0 18px 18px 0 rgba(66, 76, 94, 0.12),
      0 10px 10px 0 rgba(0, 0, 0, 0.1);
  }
  .rrs--options-visible .rrs__label {
    color: ${(props) => props.theme.colors.blue};
  }
  .rrs__option {
    cursor: pointer;
    margin: 0;
    border-top: #eee 1px solid;
    padding: 1rem;
  }

  .rrs__option_padding {
    padding: 1rem;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .rrs__option_heading {
    background: ${(props) => props.theme.colors.blue};
    color: white;
    ${clearFix()}
  }

  .rrs__option_heading_clear {
    color: ${(props) => props.theme.colors.grey_op80};
  }

  .rrs__option_clear {
    float: right;
  }

  .rrs__option--next-selection {
    color: ${(props) => props.theme.colors.blue} !important;
    background-color: #e1f5fe;
  }

  .rrs__option * {
    pointer-events: none;
  }

  .rrs__option_heading_action {
    pointer-events: auto !important;
  }

  .rrs__option:first-of-type {
    border-top: 0;
  }

  .rrs__option:focus {
    outline: 0;
  }

  .rrs__option:hover {
    color: ${(props) => props.theme.colors.blue};
  }

  .rrs__option:active {
    background: #e1f5fe;
  }

  .rrs__option.rrs__option--selected {
    color: ${(props) => props.theme.colors.blue};
    background-color: ${(props) => props.theme.colors.blue_light};
  }

  .rrs__label {
    padding: 0 2rem 0 1rem;
    display: inline-flex;
    width: 100%;
    max-width: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: inherit;
    background: transparent;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${media.MediumScreenUp`
    border-left: 1px solid ${(props) => props.theme.colors.blue_op30};
    `}
  }

  .rrs:first-child .rrs__label {
    border-left: 0;
  }

  .rrs + .rrs__button--disabled .rrs__label {
    ${media.MediumScreenUp`
    border-left: 1px solid ${(props) =>
      props.theme.colors.grey_light_op30} !important;
    `}
  }

  .rrs--options-visible .rrs__label {
    outline: 0;
  }

  .rrs__button:focus .rrs__label,
  button:focus {
    outline: 3px solid ${(props) => props.theme.colors.blue_mid};
    border-right: 0;
    z-index: 2;
    position: relative;
  }

  .rrs__label {
    font-size: inherit;
    background: transparent;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rrs--has-changed .rrs__label {
    color: ${(props) => props.theme.colors.blue};
  }

  .rrs--has-changed .rrs__button--disabled .rrs__label {
    color: ${(props) => props.theme.colors.grey_light_op30} !important;
  }

  .rrs__label__text {
    padding-right: 15px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rrs__multiselect-label {
    display: inline-flex;
    max-width: 100%;
    line-height: 1;
  }

  .rrs__multiselect-label__text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .rrs__multiselect-label__badge {
    border: 2px solid ${(props) => props.theme.colors.grey_light_op30};
    padding: 1px 6px 2px;
    margin: 0 0 0 5px;
    border-radius: 8px;
    color: ${(props) => props.theme.colors.blue};
    top: 1px;
    position: relative;
    font-size: 11px;
    vertical-align: middle;
    display: inline-block;
  }

  .caret-icon {
    position: absolute;
    right: 1rem;
    top: 1.25rem;
    fill: #333;
  }

  .rrs--options-visible .caret-icon {
    transform: rotate(180deg);
  }

  .rrs__options {
    transition: all 0.2s ${(props) => props.theme.ease.ease_out_expo};
    transition-property: max-height, opacity;
    max-height: 0;
    opacity: 0;
  }

  .rrs--options-visible .rrs__options {
    opacity: 1;
  }

  /* MultiSelect checkbox icon */
  .checkbox {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    border: 2px solid ${(props) => props.theme.colors.grey_light_op30};
    margin: 2px 10px 2px 0;
    border-radius: 50%;
    transition: border-color 0.8s ${(props) => props.theme.ease.ease_out_expo};
  }

  .rrs__option.rrs__option--selected .checkbox {
    border: 2px solid ${(props) => props.theme.colors.grey_light_op65};
  }

  .checkbox-icon {
    fill: transparent;
    transition: fill 0.25s ${(props) => props.theme.ease.ease_out_expo} 0.15s;
    position: absolute;
    left: 2px;
    top: -1px;
  }

  .rrs__option.rrs__option--selected .checkbox-icon {
    fill: ${(props) => props.theme.colors.blue};
  }

  .tab {
    display: inline-block;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 4px;
    transform: translate(0, -1px);
    line-height: 1;
    padding: 3px 10px 2px;
    margin: 0 4px 0 0;
    font-size: 16px;
  }

  .rrs__option_center {
    text-align: center;
  }

  .rrs__option_heading__tab {
    display: inline-block;
    background: ${(props) => props.theme.colors.blue};
    color: white;
    border: 1px ${(props) => props.theme.colors.white_op30} solid;
    border-radius: 4px;
    line-height: 1;
    padding: 6px 10px 8px;
    margin-top: 3px;
    margin-bottom: 3px;
    width: 47%;
    font-size: 14px;
    ${media.LargeScreenUp`
    font-size: 12px;
    margin-top: 0px;
    margin-bottom: 5px;
    padding: 4px 10px 6px;
    `}
    cursor: pointer;
    &:hover {
      border: 1px ${(props) => props.theme.colors.white_op65} solid;
    }
  }

  .rrs__option_heading__tab:last-child {
    margin-left: 3%;
  }

  .active.rrs__option_heading__tab {
    background: white;
    color: ${(props) => props.theme.colors.grey_op80};
  }
`
